import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
  FormsModule as AngularFormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatSelectModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatTableModule,
  MatTooltipModule,
} from "@angular/material";
import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { CpfCnpjMaskPipeModule } from "../forms/cpf-cnpj-mask.pipe";
import { TextMaskModule } from "angular2-text-mask";
import { DashboardModule } from "../dashboard/dashboard.module";
import { FormsModule } from "../forms/forms.module";
import { SharedModule } from "../shared/shared.module";
import { PackageCreateFormComponent } from "./package-create-form/package-create-form.component";

import { PackagesRoutingModule } from "./packages-routing.module";
import { PackageCreateComponent } from "./package-create/package-create.component";
import { PackageListComponent } from "./package-list/package-list.component";
import { PackageListElementActionsComponent } from "./package-list-element-actions/package-list-element-actions.component";
import { FinancialApiService } from "../services/financial.service";
import { MdePopoverModule } from "@material-extended/mde";

@NgModule({
  declarations: [
    PackageCreateFormComponent,
    PackageCreateComponent,
    PackageListComponent,
    PackageListElementActionsComponent,
  ],
  imports: [
    CommonModule,
    DashboardModule,
    FlexLayoutModule,
    PackagesRoutingModule,
    FormsModule,
    AngularFormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatTooltipModule,
    SharedModule,
    TextMaskModule,
    CpfCnpjMaskPipeModule,
    MdePopoverModule
  ],
  exports: [PackageCreateComponent],
  entryComponents: [PackageCreateComponent, PackageListComponent],
  providers: [FinancialApiService],
})
export class PackagesModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appEncomendaListagem",
      downgradeComponent({ component: PackageListComponent })
    )
    .directive(
      "appEncomendaAdicionar",
      downgradeComponent({ component: PackageCreateComponent })
    );
} catch (e) {}
